import Footer from "../../../components/footer";
import ScrollableContainer from "../../../layout/scrollable-container";
import Container from "../../../layout/container";

import TransitionWrapper from "../../../components/transition-wrapper/TransitionWrapper";
import { DestinationAccountControllerType } from "../useDestinationAccount";
import { TRANSFER_FLOW_IN, TRANSFER_FLOW_IN_WITH_SOURCE_ACCS } from "../../../typings";
import { AccountTile, Button } from "@manifesthhqinc/ui-library";
import { TileContainer } from "./styles";
import { HeadlineMedium } from "../../../components/font";
import HeadingContainer from "../../../layout/heading-container";

const MainScreen = (props: DestinationAccountControllerType) => {
  const { onClickContinue, currentDestinationDetails, isEmployerSponsored, transferFlow } = props;
  return (
    <TransitionWrapper>
      <ScrollableContainer name="destination-overview">
        <Container>
          <HeadingContainer paneVariant="form" withProgressBar>
            <HeadlineMedium $textAlign="center">
              {transferFlow === TRANSFER_FLOW_IN || transferFlow === TRANSFER_FLOW_IN_WITH_SOURCE_ACCS
                ? "Confirm the destination account you want to transfer into:"
                : "Your destination account:"}
            </HeadlineMedium>
          </HeadingContainer>

          <TileContainer $flexDirection="column" $width="100%" $marginTop={"24px"}>
            <AccountTile
              type="destination-account"
              title={
                isEmployerSponsored ? currentDestinationDetails.planSponsor : currentDestinationDetails.providerName
              }
              subtitle={
                isEmployerSponsored
                  ? currentDestinationDetails.providerName || "Employer sponsored account"
                  : "Individual Retirement Account"
              }
            />
          </TileContainer>
        </Container>
      </ScrollableContainer>
      <Footer>
        {(transferFlow === TRANSFER_FLOW_IN || transferFlow === TRANSFER_FLOW_IN_WITH_SOURCE_ACCS) && (
          <p className="text-center disclaimer-text">
            Next, review your personal details to verify your identity for your transfer.
          </p>
        )}
        <Button name="continue" onClick={onClickContinue} size="large">
          Continue
        </Button>
      </Footer>
    </TransitionWrapper>
  );
};

export default MainScreen;
